// frontend/src/pages/SettingsPage.js
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const SettingsPage = () => {
    // --- Correção nas Declarações de Estado ---
    const [shopName, setShopName] = useState(''); // << Adicionado shopName
    const [accessToken, setAccessToken] = useState(''); // << Adicionado accessToken
    const [isLoading, setIsLoading] = useState(false); // << Adicionado isLoading
    const [isChecking, setIsChecking] = useState(false); // << Adicionado isChecking
    const [currentShopName, setCurrentShopName] = useState(''); // << Adicionado currentShopName
    const [saveStatus, setSaveStatus] = useState({ message: '', type: '' }); // << Adicionado saveStatus
    const [checkStatus, setCheckStatus] = useState({ message: '', type: '' }); // << Adicionado checkStatus
    const [showTokenInput, setShowTokenInput] = useState(true); // Este já estava correto
    // -------------------------------------------

    const { user } = useAuth();

    // --- Função fetchCurrentCredentials ---
    const fetchCurrentCredentials = useCallback(async () => {
        // console.log("Buscando credenciais atuais...");
        try {
            const response = await api.get('/shopify/credentials');
            if (response.data && response.data.shopName) {
                 // console.log("Credenciais encontradas:", response.data);
                setCurrentShopName(response.data.shopName);
                setShopName(response.data.shopName);
                setShowTokenInput(false); // Esconde input se já salvo
            } else {
                // console.log("Nenhuma credencial encontrada.");
                setCurrentShopName('');
                setShopName('');
                setShowTokenInput(true); // Mostra input se não salvo
            }
        } catch (error) {
            if (error.response && error.response.status !== 404) {
                console.error("Erro ao buscar credenciais:", error);
                setSaveStatus({ message: 'Erro ao carregar configurações atuais.', type: 'error' });
            } else {
                 console.log("Nenhuma credencial configurada ainda.");
                 setCurrentShopName('');
                 setShopName('');
            }
            // Garante que o input seja mostrado se houver erro ao buscar
            setShowTokenInput(true);
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Não precisa de dependências aqui

    // --- Efeito para buscar credenciais ---
    useEffect(() => {
        if (user) {
            fetchCurrentCredentials();
        }
    }, [user, fetchCurrentCredentials]);

    // --- Função handleSaveChanges ---
    const handleSaveChanges = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSaveStatus({ message: '', type: '' });
        setCheckStatus({ message: '', type: '' });

        // Validação (Token obrigatório apenas se input visível)
        if (showTokenInput && !accessToken.trim()) {
            setSaveStatus({ message: 'Access Token é obrigatório ao adicionar ou alterar.', type: 'error' });
            setIsLoading(false);
            return;
        }
        if (!shopName.trim() || !shopName.includes('.myshopify.com')) {
            setSaveStatus({ message: 'Nome da Loja inválido.', type: 'error' });
            setIsLoading(false);
            return;
        }

        try {
            // Envia token apenas se visível e preenchido
            const payload = {
                shopName: shopName.trim(),
                ...(showTokenInput && accessToken.trim() && { accessToken: accessToken.trim() }),
            };

            const response = await api.post('/shopify/credentials', payload);

            setSaveStatus({ message: response.data.message || 'Credenciais salvas com sucesso!', type: 'success' });
            setCurrentShopName(shopName.trim());
            setAccessToken(''); // Limpa estado do token
            setShowTokenInput(false); // Esconde input

        } catch (error) {
            console.error("Erro ao salvar credenciais:", error);
            setSaveStatus({ message: error.response?.data?.message || 'Falha ao salvar credenciais.', type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    // --- Função handleCheckConnection ---
     const handleCheckConnection = async () => {
        setIsChecking(true);
        setCheckStatus({ message: '', type: '' });
        setSaveStatus({ message: '', type: '' });

        try {
            const response = await api.get('/shopify/check-connection');
            setCheckStatus({ message: response.data.message || 'Conexão bem-sucedida!', type: 'success' });
        } catch (error) {
            console.error("Erro ao verificar conexão:", error);
            setCheckStatus({ message: error.response?.data?.message || 'Falha na conexão.', type: 'error' });
        } finally {
            setIsChecking(false);
        }
    };

    // --- JSX (O restante do código JSX permanece o mesmo) ---
    return (
        <div className="p-4 md:p-6 lg:p-8">
             <h1 className="text-2xl font-semibold text-gray-800 mb-6">
                Configurações da Loja Shopify
            </h1>
            {/* ... resto do JSX ... */}
             <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
                <form onSubmit={handleSaveChanges} className="space-y-6">
                   {/* Campo Nome da Loja */}
                    <div>
                        <label htmlFor="shopName" className="block text-sm font-medium text-gray-700">
                            Nome da Loja Shopify
                        </label>
                        <input
                            id="shopName"
                            name="shopName"
                            type="text"
                            required
                            value={shopName} // << Usa shopName
                            onChange={(e) => setShopName(e.target.value)} // << Usa setShopName
                            disabled={isLoading} // << Usa isLoading
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70"
                            placeholder="sua-loja.myshopify.com"
                            aria-describedby="shopName-description"
                        />
                         <p className="mt-1 text-xs text-gray-500" id="shopName-description">
                            Exatamente como aparece na barra de endereços do admin Shopify.
                        </p>
                    </div>

                    {/* Campo Access Token - Renderização Condicional */}
                     <div>
                        <label htmlFor="accessToken" className="block text-sm font-medium text-gray-700">
                            API Access Token
                        </label>
                        {showTokenInput ? (
                            <>
                                <input
                                    id="accessToken"
                                    name="accessToken"
                                    type="password"
                                    required
                                    value={accessToken} // << Usa accessToken
                                    onChange={(e) => setAccessToken(e.target.value)} // << Usa setAccessToken
                                    disabled={isLoading} // << Usa isLoading
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70"
                                    placeholder="shpat_********************************"
                                    aria-describedby="accessToken-description"
                                />
                                 <p className="mt-1 text-xs text-gray-500" id="accessToken-description">
                                    Obtenha de um App Privado (legado) ou App Customizado nas configurações da sua loja Shopify.
                                </p>
                            </>
                        ) : (
                             <div className="mt-1 px-3 py-2 border border-gray-200 bg-gray-50 rounded-md text-sm text-gray-500 italic flex justify-between items-center">
                                <span>Token salvo com segurança.</span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowTokenInput(true);
                                        setAccessToken(''); // << Usa setAccessToken
                                        setSaveStatus({ message: '', type: '' }); // << Usa setSaveStatus
                                        setCheckStatus({ message: '', type: '' }); // << Usa setCheckStatus
                                    }}
                                    className="ml-4 text-xs font-medium text-indigo-600 hover:text-indigo-800 focus:outline-none"
                                    disabled={isLoading || isChecking} // << Usa isLoading e isChecking
                                >
                                    Alterar Token
                                </button>
                            </div>
                        )}
                    </div>

                     {/* Exibição de Status ao Salvar */}
                     {saveStatus.message && ( // << Usa saveStatus
                        <p className={`text-sm text-center font-medium ${
                            saveStatus.type === 'success' ? 'text-green-600' : 'text-red-600'
                        }`}>
                            {saveStatus.message}
                        </p>
                    )}

                     {/* Botão Salvar */}
                    <div className="flex justify-end">
                        <button
                            type="submit"
                            disabled={isLoading || isChecking} // << Usa isLoading e isChecking
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoading ? 'Salvando...' : 'Salvar Alterações'} {/* << Usa isLoading */}
                        </button>
                    </div>
                </form>

                {/* Divisor e Verificação de Conexão */}
                <hr className="my-8" />
                 <div className="space-y-4">
                    <h3 className="text-lg font-medium text-gray-900">
                        Verificar Conexão
                    </h3>
                    <p className="text-sm text-gray-600">
                        Após salvar as credenciais, use este botão para confirmar se a conexão com sua loja
                         {currentShopName && <span className='font-semibold'> ({currentShopName})</span>} {/* << Usa currentShopName */} está funcionando.
                    </p>

                    {/* Exibição de Status da Verificação */}
                     {checkStatus.message && ( // << Usa checkStatus
                        <p className={`text-sm text-center font-medium ${
                            checkStatus.type === 'success' ? 'text-green-600' : 'text-red-600'
                        }`}>
                            {checkStatus.message}
                        </p>
                    )}

                     <div className="flex justify-start">
                        <button
                            onClick={handleCheckConnection}
                            disabled={isChecking || isLoading || !currentShopName} // << Usa isChecking, isLoading, currentShopName
                            className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isChecking ? 'Verificando...' : 'Testar Conexão'} {/* << Usa isChecking */}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;